import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { ReactNode, useState } from "react";

interface SectionProps
{
   title: ReactNode;
   /** Optional content rendered next to the title (e.g. image count) */
   extra?: ReactNode;
   children?: ReactNode;
   defaultOpen?: boolean;
}

export const Section = ({ title, extra, children, defaultOpen = true }: SectionProps) =>
{
   const [open, setOpen] = useState(defaultOpen);

   return (
      <div className="px-6">
         <div className="bg-[var(--neutral-950)] rounded-md p-3 mb-4 shadow">
            {/* HEADER */}
            <div
               className={
                  "flex items-center justify-between cursor-pointer " +
                  (open ? "mb-3" : "")
               }
               onClick={() => setOpen(!open)}
            >
               <div className="flex items-center gap-2 w-full justify-between">
                  <div className="text-[#F5F6FA] text-sm font-semibold tracking-wide uppercase flex items-center gap-2">
                     {title}
                  </div>
                  <div className="flex items-center gap-3">
                     {extra}
                     {open ? (
                        <DownOutlined style={{ fontSize: "12px" }} />
                     ) : (
                        <RightOutlined style={{ fontSize: "12px" }} />
                     )}
                  </div>
               </div>
            </div>

            {/* CONTENT — kept mounted so collapsing/expanding doesn't unmount
                children and re-run their effects, e.g. re-fetching image
                thumbnails. Uses the grid-rows 1fr↔0fr trick so the collapse
                animates accurately in both directions (no max-height snap). */}
            <div
               className={`grid transition-all duration-300 ease-in-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
            >
               <div className="overflow-hidden min-h-0">
                  <div className="text-sm text-slate-200">{children}</div>
               </div>
            </div>
         </div>
      </div>
   );
};

interface RowProps
{
   label: ReactNode;
   value?: ReactNode;
   highlight?: boolean;
   warning?: boolean;
}

export const Row = ({ label, value, highlight, warning }: RowProps) =>
{
   const isEmpty = value === undefined || value === null || value === "";

   return (
      <div className="flex justify-between py-1 w-full">
         <p className="mb-1 text-des  w-1/3">{label}</p>

         <span
            className={`w-2/3 text-right ${warning
               ? "text-red-500"
               : highlight
                  ? "text-cyan-400"
                  : "text-slate-200"
               }`}
         >
            {isEmpty ? "--" : value}
         </span>
      </div>
   );
};
